import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { EDITORIAL_IMAGES } from "../lib/editorialImages";

const Eyebrow = ({ children }) => (
  <p className="text-[11px] tracking-[0.22em] uppercase text-mocha">{children}</p>
);

const HERO = EDITORIAL_IMAGES.architecture;

export default function WaitlistThanks() {
  const [params] = useSearchParams();
  const pos = params.get("pos");
  const role = params.get("role") || "client";

  return (
    <div className="pt-16 min-h-screen flex items-center" data-testid="waitlist-thanks">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-24 grid lg:grid-cols-12 gap-12 items-center w-full">
        <div className="lg:col-span-7 reveal">
          <Eyebrow index="—">You&rsquo;re on the list</Eyebrow>
          <h1 className="mt-8 font-serif text-6xl md:text-8xl leading-[0.9] tracking-editorial">
            Thank you,<br />
            <span className="italic text-espresso">quietly.</span>
          </h1>

          {pos && (
            <p className="mt-8 font-serif italic text-3xl text-mocha">
              You&rsquo;re #{pos} in line.
            </p>
          )}

          <p className="mt-8 max-w-lg text-ink/70 leading-relaxed text-lg">
            {role === "salon"
              ? "We'll reach out in the next few days to chat about bringing your studio onto FYLLR — we keep our onboarding hand-held and calm."
              : "We'll drop you a note the moment FYLLR opens in your city. Expect an invitation — not a notification."}
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-3 rounded-full bg-espresso text-bone px-7 py-3.5 text-[11px] tracking-[0.26em] uppercase hover:scale-[1.03] transition-transform"
              data-testid="thanks-back-home"
            >
              Return home <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
            <a
              href="https://www.instagram.com/fyllr.au/"
              target="_blank"
              rel="noreferrer noopener"
              className="inline-flex items-center gap-3 text-[11px] tracking-[0.26em] uppercase text-espresso link-underline"
              data-testid="thanks-brand-link"
            >
              Follow on Instagram
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 reveal" style={{ animationDelay: "180ms" }}>
          <div className="aspect-[4/5] overflow-hidden bg-sand">
            <img src={HERO} alt="" className="w-full h-full object-cover" />
          </div>
          <p className="mt-4 text-[10px] tracking-[0.24em] uppercase text-mocha text-right">
            FYLLR · Melbourne · 2026
          </p>
        </div>
      </div>
    </div>
  );
}
